'use client'

import { useState } from 'react'

import c from 'clsx'

import { Typography } from './typography'

interface TagProps {
  name: string
  isSelected?: boolean
  filterItem?: (item: string) => void
}

export const Tag: React.FC<TagProps> = (props) => {
  const [isActive, setIsActive] = useState(props.isSelected ?? false)
  const [isHoverDisabled, setIsHoverDisabled] = useState(false)

  const handleClick = () => {
    setIsActive((val) => !val)
    setIsHoverDisabled(true)
    if (props.filterItem) props.filterItem(props.name)
  }

  const handleMouseLeave = (isHoverDisabled: boolean) => {
    if (isHoverDisabled) setIsHoverDisabled(false)
  }

  const filterClassNames = c('cursor-pointer', {
    'bg-paychex-blue': isActive,
    'hover:bg-blue-90 hover:transition-colors hover:duration-250':
      isActive && !isHoverDisabled,
    'hover:border-blue-10 hover:bg-white hover:transition-colors hover:duration-250':
      !isActive && !isHoverDisabled,
  })

  return (
    <button
      className={c(
        'w-fit rounded-[5px] border border-transparent bg-blue-10 p-2 transition-colors duration-250',
        { [filterClassNames]: props.filterItem }
      )}
      onClick={handleClick}
      onMouseLeave={() => handleMouseLeave(isHoverDisabled)}
    >
      <Typography
        variant="tag"
        color={isActive && props.filterItem ? 'white' : 'paychex-blue'}
        weight="bold"
      >
        {props.name}
      </Typography>
    </button>
  )
}
